export interface PendingPfEmployee {
    EmployeeID?: number;
    pfPolicyId?: number;
    UAN?: string;
    pfAccountNumber?: string;
    nomineeName?: string;
    nomineeRelation?: string;
    status?: string;
}

export interface PendingDeletePfEmployee {
    awaitingEmployee?: boolean;
}

export const DEFAULT_STATUS = "active";

export const startCreateEmployeeMappingFlow = (
    setPending: (data: PendingPfEmployee | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPending({});
    pushAIChat("Sure! Which employee should be mapped to PF?");
    speak("Which employee should be mapped to PF?");
    window.dispatchEvent(
        new CustomEvent("ai-suggest-options", { detail: { type: "pf-employee" } })
    );
};

export const processPendingEmployeeMapping = (
    text: string,
    pending: PendingPfEmployee,
    setPending: (data: PendingPfEmployee | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — EMPLOYEE
    if (!pending.EmployeeID) {
        pushAIChat("Please select an employee from the list.");
        speak("Please select an employee.");
        return;
    }

    // STEP 2 — PF POLICY
    if (!pending.pfPolicyId) {

        return;
    }

    // STEP 3 — UAN
    if (!pending.UAN) {
        const val = text.trim();
        if (!val) {
            pushAIChat("UAN is required.");
            speak("Please provide UAN.");
            return;
        }
        setPending({ ...pending, UAN: val });
        pushAIChat("What is the PF account number?");
        speak("What is the PF account number?");
        return;
    }

    // STEP 4 — ACCOUNT NUMBER
    if (!pending.pfAccountNumber) {
        const val = text.trim();
        if (!val) {
            pushAIChat("PF account number is required.");
            speak("Please provide PF account number.");
            return;
        }
        setPending({ ...pending, pfAccountNumber: val });
        pushAIChat("What is the nominee name?");
        speak("What is the nominee name?");
        return;
    }

    // STEP 5 — NOMINEE NAME
    if (!pending.nomineeName) {
        const val = text.trim();
        if (!val) {
            pushAIChat("Nominee name is required.");
            speak("Please provide nominee name.");
            return;
        }
        setPending({ ...pending, nomineeName: val });
        pushAIChat("What is the nominee relation?");
        speak("What is the nominee relation?");
        return;
    }

    // STEP 6 — NOMINEE RELATION
    if (!pending.nomineeRelation) {
        const val = text.trim();
        if (!val) {
            pushAIChat("Nominee relation is required.");
            speak("Please provide nominee relation.");
            return;
        }

        const finalData = {
            ...pending,
            nomineeRelation: val,
            status: DEFAULT_STATUS,
        };

        pushAIChat("Creating PF employee mapping...");
        speak("Creating PF employee mapping.");

        window.dispatchEvent(
            new CustomEvent("ai-create-pf-employee", {
                detail: finalData,
            })
        );

        setPending(null);
        return;
    }
};

export const startDeleteEmployeeMappingFlow = (
    setPendingDelete: (data: PendingDeletePfEmployee | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPendingDelete({ awaitingEmployee: true });
    pushAIChat("Which PF employee mapping do you want to delete?");
    speak("Which PF employee mapping do you want to delete?");
};

export const processPendingDeleteEmployeeMapping = (
    text: string,
    pending: PendingDeletePfEmployee,
    setPendingDelete: (data: PendingDeletePfEmployee | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingEmployee) return;

    const cleanName = text.trim();

    if (!cleanName) {
        pushAIChat("Please provide a valid employee name.");
        speak("Please provide a valid employee name.");
        return;
    }

    pushAIChat(`Deleting PF mapping for ${cleanName}...`);
    speak(`Deleting PF mapping for ${cleanName}`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-pf-employee", {
            detail: { employeeName: cleanName },
        })
    );

    setPendingDelete(null);
};
